import * as O from "fp-ts/Option"
import * as A from "fp-ts/Array"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import * as S from "fp-ts/string"

import { isPresent } from "../../_common/checks"

export type ValidatedCardPromoBadges<T> = T & { content: { title: string } }

export const buildPromoBadgesContent = <
    T extends { configurationCode: O.Option<string> },
    C extends { code: string; content?: { title?: string; showInCruiseCard?: boolean } },
>(
    promotions: readonly T[],
    promoBadgesContent: C[],
): readonly ValidatedCardPromoBadges<C>[] => {
    return F.pipe(
        promotions,
        ROA.map((promo) => promo.configurationCode),
        ROA.compact,
        ROA.uniq(S.Eq),
        ROA.map((c) =>
            F.pipe(
                promoBadgesContent,
                A.findFirst((x) => x.code == c),
                O.map((c) => {
                    const title = c.content?.title
                    if (!isPresent(title)) return O.none
                    return O.some({ ...c, content: { ...c.content, title } })
                }),
                O.compact,
                O.filter((x) => !!x.content.showInCruiseCard),
            ),
        ),
        ROA.compact,
    )
}
